<template>
	<div class="about-container">
		<img class="popularBgImg" src="../assets/Home/popularBgImg.png" />
		<div class="detailsBox">
			<div class="title">
				常见问题
			</div>
			<div class="problemList">
				<div class="problemItem" v-for="(item,index) in problemData" :key="index">
					<div class="problemTitleBox" @click="item.isShow = item.isShow ? false : true">
						<div class="problemTitle">{{index + 1}}.{{item.title}}</div>
						<img class="icon" src="../assets/Home/addIcon.png" v-if="!item.isShow" />
						<img class="icon" src="../assets/Home/reduceIcon.png" v-else />
					</div>
					<div class="problemContent" v-if="item.isShow">
						{{item.content}}
					</div>
				</div>
			</div>
			<PagePagination style="padding: .48rem 0 .32rem;" :currentPage="currentPage" :total="total"
				@current-change="onPageChange" />
		</div>
	</div>
</template>

<script>
	import PagePagination from '../components/PagePagination.vue'
	export default {
		name: 'CommonProblem',
		components: {
			PagePagination
		},
		data() {
			return {
				problemData: [],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
			}
		},
		mounted() {
			this.problemList()
		},
		methods: {
			// 页码变化处理
			onPageChange(newPage) {
				this.currentPage = newPage
				this.problemList()
			},
			problemList() {
				this.$api.post('/Other/gonggao_list', {
					p: this.currentPage,
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.problemData = []
						res.data.list.forEach(item => {
							this.problemData.push({
								...item,
								isShow: false
							})
						})
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			}

		},
	}
</script>

<style lang="scss" scoped>
	.about-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
		position: relative;

		.popularBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.detailsBox {
		margin: .24rem auto .8rem;
		padding: .4rem .4rem 0;
		width: 12rem;
		border-radius: .08rem;
		background: #FFFFFF;
		z-index: 1;

		.title {
			font-weight: 700;
			font-size: .32rem;
			color: #333333;
		}

		.problemList {
			display: flex;
			flex-direction: column;

			.problemItem {
				margin-top: .24rem;
				display: flex;
				flex-direction: column;

				.problemTitleBox {
					display: flex;
					align-items: center;
					justify-content: space-between;
					cursor: pointer;

					.problemTitle {
						font-weight: 500;
						font-size: .16rem;
						color: #161616;
						line-height: .24rem;
					}

					.icon {
						width: .14rem;
						height: .14rem;
					}
				}

				.problemContent {
					margin: .08rem .18rem 0;
					font-weight: 400;
					font-size: .12rem;
					color: #73767C;
					line-height: .2rem;
				}
			}
		}
	}
</style>